import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import CashReportMiddleware from '../../../../middleware/modules/report/cash-report';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
import CashReport from '../../../../components/modules/report/cash-report';
// middlewares
 

const mapStateToProps = ({ auth,cashReport }) => ({
  isProcessing: cashReport.isProcessing,
  isError: cashReport.isError,
  errorMessage: cashReport.errorMessage,
  dataList:cashReport.dataReport,
  showModal:cashReport.showModal,
  helperCashReport:cashReport.helperCashReport
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>CashReportMiddleware.getHelper(),
    reset: () =>CashReportMiddleware.resetList(),
    setDataReport: (data) =>CashReportMiddleware.list(data),
    excel: (data) =>CashReportMiddleware.showExcel(data),
  }, dispatch);
};
class CashReportContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    dataList: PropTypes.any,
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
  }

  setDataReport() {
    this.props.setDataReport();
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.getHelper()
  
  }

  render() {
    const {dataList, helperCashReport, dataReport} = this.props;
    console.log('helper',dataReport)
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Cash Report")}
          </title>
        </Helmet>
      <CashReport
        {...this.props}
        data={dataList}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashReportContainer);
